import CharityDonationViewController from './CharityDonationViewController';

export default CharityDonationViewController;
